/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import AppliedFilter from "../Components/AppliedFilter/AppliedFilter";
import { DATES, EVENT_NAME, Constants } from "../Components/constant";
import useParamsQuery from "../Components/hooks/useParamsQuery";
import { isEmptyObj } from "../Components/helper";
import styles from "./CashReport.styles";
import DateRangePicker from "../Components/DateRangePicker/DateRangePicker";
import OrganizationStructure from "../Components/OrganizationStructureNew/OrganizationStructure";
import Popover from "../Components/Popover/NewPopover";
// import { getFilters, getRoutePath } from "./utils";
import { SERVICES } from "../../../components/Layout/Services";
import Loader from "../../../components/Loader/Loader";
import SearchIconWithPeople from "../../../components/Svg/SearchIconWithPeople";
import EmptyFileIcon from "../../../components/Svg/EmptyFile";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
// import GenericTable from "../../../components/Layout/Table/GenericTable";
import GenericTable from "./Components/GenericTable";
import Button from "../../../components/Layout/Button";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import ExportButton from "./Components/ExportButton/ExportButton";
import OrganizationStructureForUser from "../../Member/Components/OrganizationStructureNew/OrganizationStructureForUser";

const LOADER_DELAY = 1000;
const PAGE = "page";

const initialFormValue = {
  dateOfBirthFrom: new Date(),
  dateOfBirthTo: new Date(),
};
function CashReport() {
  const TITLE = "Cash Reports - BSG ContributionAdmin";
  const [searchData, setSearchData] = useState({});
  const [data, setData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [clearContributions, setClearContributions] = useState(false);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [selectedSortMethod, setSelectedSortMethod] = useState("");
  const [profileData, setProfileData] = useState({});
  const isContributionAdmin =
    profileData?.assignedRoles?.includes("contributionAdmin");
  const baseHeaders = [
    "S.No.",
    // "Member ID",
    "Member Name",
    // "Address",
    "Payment Mode",
    "Receipt No",
    "Receipt Date",
    // "Order Number",
    "Cheque/DD No",
    "Cheque Date",
    "Bank Name",
    // "Payable City",
    "Amount",
    "Created By",
    "Purpose",
    // "UIN Type",
    // "UIN No",
    // "Created By",
    // "Payment Mode",
    // "Payment Gateway",
  ];
  const tableHeaders = isContributionAdmin
    ? [...baseHeaders, "UIN Type", "UIN No"]
    : baseHeaders;
  const [values, setValues] = useState({
    areaId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });
  const [orgNames, setOrgNames] = useState({
    areaName: null,
    zoneName: null,
    regionName: null,
    chapterName: null,
    districtName: null,
    blockName: null,
  });
  // const [selectedPayableCity, setSelectedPayableCity] = useState("");
  // const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  // const [selectedPaymentGateway, setSelectedPaymentGateway] = useState("");
  // const [selectedUinType, setSelectedUinType] = useState("");
  // const [selectedReceiptType, setSelectedReceiptType] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [personalDetails, setPersonalDetails] = useState({
    memberId: null,
    fullName: null,
  });
  const [amountValue, setAmountValue] = useState(null);
  const [dataEnetrdBy, setDataEnetrdBy] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const handleAmountChange = (value) => {
    setAmountValue(value);
  };
  const handleDataEnterdBy = (value) => {
    // console.log(value);
    setDataEnetrdBy(value);
  };
  const updateSortingMethod = (value) => {
    setSelectedSortMethod(value);
  };
  const handlePersonalDetailsChange = (name, value) => {
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };
  const [advancedSearchValues, setAdvancedSearchValues] = useState({
    selectedPayableCity: [],
    selectedPaymentMethod: [],
    selectedPaymentGateway: [],
    selectedUinType: [],
    selectedReceiptType: [],
  });
  // const updatePayableCity = (value) => {
  //   setSelectedPayableCity(value);
  // };
  // const updatePaymentMethod = (value) => {
  //   setSelectedPaymentMethod(value);
  // };
  // const updatePaymentGateway = (value) => {
  //   setSelectedPaymentGateway(value);
  // };
  // const updateUinType = (value) => {
  //   setSelectedUinType(value);
  // };
  // const updateReceiptType = (value) => {
  //   setSelectedReceiptType(value);
  // };
  const updateOrganizationStructureValues = (updatedValues) => {
    // console.log(updatedValues);
    setValues(updatedValues);
  };

  // const updateSearchParam = (query) => {
  //   if (query?.length) {
  //     navigate(`${getRoutePath()}?${query}`);
  //   } else {
  //     navigate(`${getRoutePath()}`);
  //   }
  // };
  // const removeKeyFromQuery = (queryObject, filterKey) => {
  //   const updatedQuery = {
  //     ...queryObject,
  //     pageNumber: 0,
  //     pageSize: Constants.DEFAULT_PAGE_SIZE,
  //   };
  //   if (DATES.includes(filterKey)) {
  //     delete updatedQuery[filterKey];
  //     delete updatedQuery[`${filterKey.split("From")[0]}To`];
  //   } else {
  //     delete updatedQuery[filterKey];
  //   }
  //   if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
  //     delete updatedQuery[PAGE];
  //   }
  //   return updatedQuery;
  // };
  // const onRemoveFilter = (filterKey) => {
  //   // setPaginationInfo(intialPaginationState);
  //   let queryObject = getQueryObject();
  //   queryObject = removeKeyFromQuery(queryObject, filterKey);
  //   const updatedQuery = queryString.stringify(queryObject);
  //   updateSearchParam(updatedQuery);
  // };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }
  const constructQueryParameters = (
    formattedStartDate,
    formattedEndDate,
    selectedSortMethod
  ) => {
    const queryParams = [];
    const optionalParams = {
      areaId: values.areaId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      districtId: values.districtId,
      blockId: values.blockId,
      // Add personal details
      memberId: personalDetails.memberId,
      fullName: personalDetails.fullName,
      // Add advanced search values
      payableCities: advancedSearchValues.selectedPayableCity.join(","),
      paymentMethodTypes: advancedSearchValues.selectedPaymentMethod.join(","),
      paymentGatewayTypes:
        advancedSearchValues.selectedPaymentGateway.join(","),
      uinTypes: advancedSearchValues.selectedUinType.join(","),
      receiptType: advancedSearchValues.selectedReceiptType.join(","),
      // id: dataEnetrdBy,
    };
    for (const key in optionalParams) {
      if (
        optionalParams[key] !== null &&
        optionalParams[key] !== undefined &&
        optionalParams[key] !== ""
      ) {
        queryParams.push(`${key}=${optionalParams[key]}`);
      }
    }
    if (
      moment(formattedStartDate, "YYYY-MM-DD", true).isValid() &&
      moment(formattedEndDate, "YYYY-MM-DD", true).isValid()
    ) {
      queryParams.push(`from=${formattedStartDate}`);
      queryParams.push(`to=${formattedEndDate}`);
    }
    // if (selectedPayableCity) {
    //   queryParams.push(`payableCities=${selectedPayableCity}`);
    // }
    // if (selectedPaymentMethod) {
    //   queryParams.push(`paymentMethodTypes=${selectedPaymentMethod}`);
    // }
    // if (selectedPaymentGateway) {
    //   queryParams.push(`paymentGatewayTypes=${selectedPaymentGateway}`);
    // }
    // if (selectedUinType) {
    //   queryParams.push(`uinTypes=${selectedUinType}`);
    // }
    // if (selectedReceiptType) {
    //   queryParams.push(`receiptType=${selectedReceiptType}`);
    // }
    if (amountValue) {
      queryParams.push(`amount=${amountValue}`);
    }
    if (dataEnetrdBy) {
      queryParams.push(`dataEnteredBy=${dataEnetrdBy}`);
    }
    if (selectedSortMethod) {
      queryParams.push(`sort=${selectedSortMethod}`);
    }
    return queryParams.join("&");
  };
  const removeFilter = () => {
    setClearContributions(true);
    setSearchParams("");
    setPersonalDetails({
      memberId: null,
      fullName: null,
    });
    setTimeout(() => {
      setClearContributions(false);
      setSearchPerformed(false);
      // setShowFilter(false);
    }, 100);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    setSearchPerformed(true);
    if (
      !initialAdvanceFormValue.dateOfBirthFrom ||
      !initialAdvanceFormValue.dateOfBirthTo
    ) {
      toast.show("Please select date", AlertStatus.ERROR);
      return;
    }
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthFrom
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthTo
    );
    try {
      setIsLoading(true);
      const url = `${
        SERVICES.GET_TOTAL_RECEIPT_REPORTS
      }?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedSortMethod
        // selectedPayableCity,
        // selectedPaymentMethod,
        // selectedPaymentGateway,
      )}`;
      const response = await get(url);
      // console.log(response);
      if (response.ok) {
        const data = await response.json();
        // console.log(data.data);
        setSearchData(data.data);
        const queryParams = constructQueryParameters(
          formattedStartDate,
          formattedEndDate,
          selectedSortMethod
        );
        const { areaId, zoneId, regionId, chapterId, districtId, blockId } =
          values;

        const {
          areaName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          blockName,
        } = orgNames;
        const orgParams = [
          areaId !== null && areaName !== null && areaName !== ""
            ? `areaName=${areaName}`
            : "",
          zoneId !== null && zoneName !== null && zoneName !== ""
            ? `zoneName=${zoneName}`
            : "",
          regionId !== null && regionName !== null && regionName !== ""
            ? `regionName=${regionName}`
            : "",
          chapterId !== null && chapterName !== null && chapterName !== ""
            ? `chapterName=${chapterName}`
            : "",
          districtId !== null && districtName !== null && districtName !== ""
            ? `districtName=${districtName}`
            : "",
          blockId !== null && blockName !== null && blockName !== ""
            ? `blockName=${blockName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");
        // setSearchParams(
        //   constructQueryParameters(
        //     formattedStartDate,
        //     formattedEndDate,
        //     // selectedPayableCity,
        //     // selectedPaymentMethod,
        //     // selectedPaymentGateway,
        //   ),
        // );
        setSearchParams(`${queryParams}${orgParams ? `&${orgParams}` : ""}`);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
    // finally {
    //   setIsLoading(false);
    // }
    document.dispatchEvent(new Event(EVENT_NAME));
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    const formattedStartDate = moment(
      initialAdvanceFormValue.dateOfBirthFrom
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(
      initialAdvanceFormValue.dateOfBirthTo
    ).format("YYYY-MM-DD");
    const queryParams = constructQueryParameters(
      formattedStartDate,
      formattedEndDate,
      selectedSortMethod
    );
    const { areaId, zoneId, regionId, chapterId, districtId, blockId } = values;

    const {
      areaName,
      zoneName,
      regionName,
      chapterName,
      districtName,
      blockName,
    } = orgNames;
    const orgParams = [
      areaId !== null && areaName !== null && areaName !== ""
        ? `areaName=${areaName}`
        : "",
      zoneId !== null && zoneName !== null && zoneName !== ""
        ? `zoneName=${zoneName}`
        : "",
      regionId !== null && regionName !== null && regionName !== ""
        ? `regionName=${regionName}`
        : "",
      chapterId !== null && chapterName !== null && chapterName !== ""
        ? `chapterName=${chapterName}`
        : "",
      districtId !== null && districtName !== null && districtName !== ""
        ? `districtName=${districtName}`
        : "",
      blockId !== null && blockName !== null && blockName !== ""
        ? `blockName=${blockName}`
        : "",
    ]
      .filter(Boolean)
      .join("&");
    try {
      // const url = `${
      //   SERVICES.GET_TOTAL_RECEIPT_REPORTS
      // }?${constructQueryParameters(
      //   formattedStartDate,
      //   formattedEndDate,
      //   // selectedPayableCity,
      //   // selectedPaymentMethod,
      //   // selectedPaymentGateway,
      // )}&pageNumber=${selectedPage}&pageSize=${10}`;
      const url = `${SERVICES.GET_TOTAL_RECEIPT_REPORTS}?${queryParams}${
        orgParams ? `&${orgParams}` : ""
      }&pageNumber=${selectedPage}&pageSize=${10}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setSearchData(data.data);
        // setSearchParams(
        //   `${constructQueryParameters(
        //     formattedStartDate,
        //     formattedEndDate,
        //     // selectedPayableCity,
        //     // selectedPaymentMethod,
        //     // selectedPaymentGateway,
        //   )}&pageNumber=${selectedPage}&pageSize=${10}`,
        // );
        setSearchParams(
          `${queryParams}${
            orgParams ? `&${orgParams}` : ""
          }&pageNumber=${selectedPage}&pageSize=${10}`
        );
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const formatUINType = (type) => {
    if (type) {
      return type.replace(/_/g, " ").toUpperCase();
    }
    return "";
  };
  useEffect(() => {
    const isContributionAdmin =
      profileData?.assignedRoles?.includes("contributionAdmin");

    if (searchData.content) {
      const updatedTableData = searchData.content.map((item, index) => {
        const row = {
          "S.No.": index + 1 + currentPage * 10,
          "Member Name": item?.paymentOrder?.fullName,
          "Payment Mode": formatUINType(
            item?.paymentOrder?.paymentTransaction?.paymentMethodType
          ),
          "Receipt No":
            item?.paymentOrder?.paymentTransaction?.externalReceiptNumber ??
            "NA",
          "Receipt Date": item?.paymentOrder?.paymentTransaction
            ?.receiptGeneratedAt
            ? moment(
                item?.paymentOrder?.paymentTransaction?.receiptGeneratedAt
              ).format("DD/MM/YYYY")
            : "NA",
          "Cheque/DD No":
            item?.paymentOrder?.paymentTransaction?.chequeNumber ?? "NA",
          "Cheque Date": item?.paymentOrder?.paymentTransaction?.chequeDate
            ? moment(item?.paymentOrder?.paymentTransaction?.chequeDate).format(
                "DD/MM/YYYY"
              )
            : "NA",
          "Bank Name":
            item?.paymentOrder?.paymentTransaction?.otherBankName ??
            item?.paymentOrder?.paymentTransaction?.drawnBankName,
          Amount: item?.paymentOrder?.amount,
          "Created By": item?.paymentOrder?.createdByName,
          Purpose: item?.paymentOrder?.donationPurposeName,
        };

        if (isContributionAdmin) {
          row["UIN Type"] = formatUINType(item?.paymentOrder?.uinType);
          row["UIN No"] = item?.paymentOrder?.uin;
        }

        return row;
      });

      setData(updatedTableData);
    }
  }, [searchData.content]);

  // useEffect(() => {
  //   Object.keys(initialFormValue).forEach((key) => {
  //     setInitialAdvanceFormValue((prev) => ({
  //       ...prev,
  //     }));
  //   });
  // }, [urlSearchParams.toString()]);
  // useEffect(() => {
  //   const queryObject = getQueryObject();
  //   if (!isEmptyObj(queryObject)) {
  //     const query = getQueryParams(queryObject)[0];
  //     setAppliedFilters(getFilters(query, metaData));
  //   }
  // }, [metaData, urlSearchParams.toString()]);
  // const clearAllFilter = () => {
  //   updateSearchParam();
  // };
  // console.log("line 394", advancedSearchValues);
  const renderAppliedFilter = (paramKey, displayName, value, onRemove) => {
    return (
      queryParams.get(paramKey) && (
        <AppliedFilter
          filter={{
            displayName,
            value,
          }}
          onRemove={onRemove}
        />
      )
    );
  };
  const onRemoveFilter = (filterKey) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    updatedSearchParams.delete(filterKey);
    setSearchParams(updatedSearchParams.toString());
  };
  const onRemoveTwoFilter = (...filterKeys) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    filterKeys.forEach((key) => {
      updatedSearchParams.delete(key);
    });

    setSearchParams(updatedSearchParams.toString());
  };
  const convertTypeFormat = (type) => {
    const formattedType = type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return formattedType;
  };
  const getEntityTitlesForPaymentgatewayTypes = () => {
    return queryParams
      ?.get("paymentGatewayTypes")
      ?.split(",")
      ?.map((name) => name.trim());
  };
  const getEntityTitlesForPaymentmethodTypes = () => {
    return queryParams
      ?.get("paymentMethodTypes")
      ?.split(",")
      ?.map((name) => convertTypeFormat(name.trim()));
  };
  const getEntityTitlesForUinTypes = () => {
    return queryParams
      ?.get("uinTypes")
      ?.split(",")
      ?.map((name) => convertTypeFormat(name.trim()));
  };
  const getEntityTitlesForReceiptTypes = () => {
    return queryParams
      ?.get("receiptType")
      ?.split(",")
      ?.map((name) => name.trim());
  };

  const filters = [
    // org values
    renderAppliedFilter("areaId", "Area", searchParams.get("areaName"), () =>
      onRemoveTwoFilter("areaId", "areaName")
    ),
    renderAppliedFilter("zoneId", "Zone", searchParams.get("zoneName"), () =>
      onRemoveTwoFilter("zoneId", "zoneName")
    ),
    renderAppliedFilter(
      "regionId",
      "Region",
      searchParams.get("regionName"),
      () => onRemoveTwoFilter("regionId", "regionName")
    ),
    renderAppliedFilter(
      "chapterId",
      "Chapter",
      searchParams.get("chapterName"),
      () => onRemoveTwoFilter("chapterId", "chapterName")
    ),
    renderAppliedFilter(
      "districtId",
      "District",
      searchParams.get("districtName"),
      () => onRemoveTwoFilter("districtId", "districtName")
    ),
    renderAppliedFilter("blockId", "Block", searchParams.get("blockName"), () =>
      onRemoveTwoFilter("blockId", "blockName")
    ),
    // Advance Search
    renderAppliedFilter(
      "paymentGatewayTypes",
      "Payment Gateway",
      getEntityTitlesForPaymentgatewayTypes()?.join(", "),
      () => onRemoveFilter("paymentGatewayTypes")
    ),
    renderAppliedFilter(
      "paymentMethodTypes",
      "Payment Method",
      getEntityTitlesForPaymentmethodTypes()?.join(", "),
      () => onRemoveFilter("paymentMethodTypes")
    ),
    renderAppliedFilter("amount", "Amount", searchParams.get("amount"), () =>
      onRemoveFilter("amount")
    ),
    renderAppliedFilter(
      "uinTypes",
      "Uin Types",
      getEntityTitlesForUinTypes()?.join(", "),
      () => onRemoveFilter("uinTypes")
    ),
    renderAppliedFilter(
      "receiptType",
      "Receipt Types",
      getEntityTitlesForReceiptTypes()?.join(", "),
      () => onRemoveFilter("receiptType")
    ),
    renderAppliedFilter("sort", "Sorting", searchParams.get("sort"), () =>
      onRemoveFilter("sort")
    ),
    // Personal Deatils
    renderAppliedFilter(
      "memberId",
      "Member Id",
      searchParams.get("memberId"),
      () => onRemoveFilter("memberId")
    ),
    renderAppliedFilter(
      "fullName",
      "Member Name",
      searchParams.get("fullName"),
      () => onRemoveFilter("fullName")
    ),
    renderAppliedFilter(
      "from",
      "Date Range",
      `${moment(searchParams.get("from")).format("DD-MMM-YYYY")} - ${moment(
        searchParams.get("to")
      ).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("from", "to")
    ),
  ];

  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    if (queryParams.get("amount") === null) {
      setAmountValue("");
    }
    if (queryParams.get("memberId") === null) {
      setPersonalDetails((prevalues) => ({
        ...prevalues,
        memberId: "",
      }));
    }
    if (queryParams.get("fullName") === null) {
      setPersonalDetails((prevalues) => ({
        ...prevalues,
        fullName: "",
      }));
    }
    if (queryParams.get("from") === null) {
      setInitialAdvanceFormValue((preValues) => ({
        ...preValues,
        dateOfBirthFrom: initialAdvanceFormValue?.dateOfBirthFrom,
        dateOfBirthTo: initialAdvanceFormValue?.dateOfBirthTo,
      }));
    }
    if (queryParams.get("sort") === null) {
      setSelectedSortMethod("");
    }
  }, [
    queryParams.get("amount"),
    queryParams.get("memberId"),
    queryParams.get("fullName"),
    clearContributions,
    // queryParams.get("from")
    queryParams.get("sort"),
  ]);
  useEffect(() => {
    getUserRole();
  }, []);
  useEffect(() => {
    if (
      profileData?.assignedRoles?.includes("contributionOfflineDataEntry") ||
      profileData?.assignedRoles?.includes("contributionAdmin")
    ) {
      setAdvancedSearchValues((prevValues) => ({
        ...prevValues,
        selectedPaymentMethod: ["CASH"],
      }));
    }
  }, [profileData]);
  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Cash Reports" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <div style={styles.filter}>
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              <DateRangePicker
                label="Date"
                name="date"
                startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
                endDateVal={initialAdvanceFormValue.dateOfBirthTo}
                onChange={(startDate, endDate) => {
                  setInitialAdvanceFormValue({
                    ...initialAdvanceFormValue,
                    dateOfBirthFrom: startDate,
                    dateOfBirthTo: endDate,
                  });
                }}
              />
              <Popover heading="Organization Structure" minWidth={413}>
                {profileData?.assignedRoles?.includes(
                  "contributionOfflineDataEntry"
                ) ? (
                  <OrganizationStructureForUser
                    clearValues={clearContributions}
                    setNameValues={setOrgNames}
                    onUpdateValues={updateOrganizationStructureValues}
                    initialAreaId={profileData?.areaId}
                    initialZoneId={profileData?.zoneId}
                    initialRegionId={profileData?.regionId}
                    initialChapterId={profileData?.chapterId}
                    disabled
                  />
                ) : (
                  <OrganizationStructure
                    clearValues={clearContributions}
                    setNameValues={setOrgNames}
                    onUpdateValues={updateOrganizationStructureValues}
                  />
                )}
                {/* <OrganizationStructure
                  clearValues={clearContributions}
                  setNameValues={setOrgNames}
                  onUpdateValues={updateOrganizationStructureValues}
                /> */}
              </Popover>
              <Button type="submit">Search</Button>
            </form>
            <Button cancel onClick={removeFilter}>
              Reset
            </Button>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <div />
            <div>
              <ExportButton />
            </div>
          </div> */}
          {searchPerformed && (
            <div style={styles.filterWrapper}>
              <div style={styles.filterContainer}>
                {filters.map((filter, index) => (
                  <>{filter}</>
                ))}
              </div>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <div />
            <div>
              <ExportButton data={data} />
            </div>
          </div>
          <div style={styles.main}>
            {appliedFilters.length ? (
              <div style={styles.filterWrapper}>
                <div style={styles.filterContainer}>
                  {/* {appliedFilters.map((filter) => (
                    <AppliedFilter
                      key={filter.key}
                      filter={filter}
                      onRemove={onRemoveFilter}
                    />
                  ))} */}
                </div>
                {/* <div style={styles.clearAll} onClick={clearAllFilter}>
                  Clear
                </div> */}
              </div>
            ) : null}
            {!searchPerformed ? (
              <div style={styles.initialContent}>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </div>
            ) : data?.length > 0 ? (
              <div>
                <GenericTable
                  tableData={data}
                  data={searchData}
                  headers={tableHeaders}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <div style={styles.initialContent}>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </div>
            )}
          </div>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}
export default CashReport;

// If we want to use AutoComplete Dropdown use commented Code otherwise use the above code
